module.exports = __webpack_public_path__ + "img/chariton_large.6c0bc805.png";